import React from 'react';

import classNames from 'classnames';

import type { DragAndDropHSide } from '../types';

import styles from './column_drop_mark.module.css';

type Props = {
  side: DragAndDropHSide;
};

const ColumnDropMark = React.forwardRef<HTMLDivElement, Props>(
  ({ side }, ref) => (
    <div
      ref={ref}
      className={classNames(
        styles.root,
        { [styles.left]: side === 'left' },
        { [styles.right]: side === 'right' },
      )}
    />
  ),
);

export default ColumnDropMark;
